import { IDropdownItem, IKhungGiaDat, ILichSuGiaDat } from "../_types_";
import thuaDatChiTiet from "./a.json";

export const KVHC_HUYEN: IDropdownItem[] = [
  { value: "0", lable: "huyện Châu đức" },
  { value: "1", lable: "huyện Côn Đảo" },
  { value: "2", lable: "huyện Đất Đỏ" },
];

export const KVHC_XA: IDropdownItem[] = [
  { lable: "Thị trấn Ngãi Giao", value: 0 },
  { lable: "Xã Bầu Chinh", value: 1 },
  { lable: "Xã Bình Ba", value: 2 },
];

export { thuaDatChiTiet };

export const BangGiaDatData = [
  {
    id: 0,
    ma: "01",
    soQuyetDinh: "11/QĐ-UBNĐ",
    ngayBanHanh: "2022-12-20T07:40:25.598Z",
    coQuanBanHanh: "Uỷ ban nhân dân tỉnh Bà rịa - Vũng tàu",
    hieuLuc: "2022-12-20T07:40:25.598Z",
    hetHieuLuc: "2022-12-20T07:40:25.598Z",
    isDeleted: true,
    createdDate: "2022-12-20T07:40:25.598Z",
    modifiedDate: "2022-12-20T07:40:25.598Z",
    createdUser: "string",
    modifiedUser: "string",
  },
  {
    id: 0,
    ma: "01",
    soQuyetDinh: "11/QĐ-UBNĐ",
    ngayBanHanh: "2022-12-20T07:40:25.598Z",
    coQuanBanHanh: "Uỷ ban nhân dân tỉnh Bà rịa - Vũng tàu",
    hieuLuc: "2022-12-20T07:40:25.598Z",
    hetHieuLuc: "2022-12-20T07:40:25.598Z",
    isDeleted: true,
    createdDate: "2022-12-20T07:40:25.598Z",
    modifiedDate: "2022-12-20T07:40:25.598Z",
    createdUser: "string",
    modifiedUser: "string",
  },
  {
    id: 0,
    ma: "01",
    soQuyetDinh: "11/QĐ-UBNĐ",
    ngayBanHanh: "2022-12-20T07:40:25.598Z",
    coQuanBanHanh: "Uỷ ban nhân dân tỉnh Bà rịa - Vũng tàu",
    hieuLuc: "2022-12-20T07:40:25.598Z",
    hetHieuLuc: "2022-12-20T07:40:25.598Z",
    isDeleted: true,
    createdDate: "2022-12-20T07:40:25.598Z",
    modifiedDate: "2022-12-20T07:40:25.598Z",
    createdUser: "string",
    modifiedUser: "string",
  },
  {
    id: 0,
    ma: "01",
    soQuyetDinh: "11/QĐ-UBNĐ",
    ngayBanHanh: "2022-12-20T07:40:25.598Z",
    coQuanBanHanh: "Uỷ ban nhân dân tỉnh Bà rịa - Vũng tàu",
    hieuLuc: "2022-12-20T07:40:25.598Z",
    hetHieuLuc: "2022-12-20T07:40:25.598Z",
    isDeleted: true,
    createdDate: "2022-12-20T07:40:25.598Z",
    modifiedDate: "2022-12-20T07:40:25.598Z",
    createdUser: "string",
    modifiedUser: "string",
  },
  {
    id: 0,
    ma: "01",
    soQuyetDinh: "11/QĐ-UBNĐ",
    ngayBanHanh: "2022-12-20T07:40:25.598Z",
    coQuanBanHanh: "Uỷ ban nhân dân tỉnh Bà rịa - Vũng tàu",
    hieuLuc: "2022-12-20T07:40:25.598Z",
    hetHieuLuc: "2022-12-20T07:40:25.598Z",
    isDeleted: true,
    createdDate: "2022-12-20T07:40:25.598Z",
    modifiedDate: "2022-12-20T07:40:25.598Z",
    createdUser: "string",
    modifiedUser: "string",
  },
  {
    id: 0,
    ma: "01",
    soQuyetDinh: "11/QĐ-UBNĐ",
    ngayBanHanh: "2022-12-20T07:40:25.598Z",
    coQuanBanHanh: "Uỷ ban nhân dân tỉnh Bà rịa - Vũng tàu",
    hieuLuc: "2022-12-20T07:40:25.598Z",
    hetHieuLuc: "2022-12-20T07:40:25.598Z",
    isDeleted: true,
    createdDate: "2022-12-20T07:40:25.598Z",
    modifiedDate: "2022-12-20T07:40:25.598Z",
    createdUser: "string",
    modifiedUser: "string",
  },
];

export const KhungGiaDatMetadata = {
  loaiDats: [
    {
      maLoaiDat: "NNP",
      tenLoaiDat: "Đất nông nghiệp",
    },
    {
      maLoaiDat: "SXN",
      tenLoaiDat: "Đất sản xuất nông nghiệp",
    },
    {
      maLoaiDat: "CHN",
      tenLoaiDat: "Đất trồng cây hàng năm",
    },
    {
      maLoaiDat: "LUA",
      tenLoaiDat: "Đất trồng lúa",
    },
    {
      maLoaiDat: "LUC",
      tenLoaiDat: "Đất chuyên trồng lúa nước",
    },
    {
      maLoaiDat: "LUK",
      tenLoaiDat: "Đất trồng lúa nước còn lại",
    },
    {
      maLoaiDat: "LUN",
      tenLoaiDat: "Đất trồng lúa nương",
    },
    {
      maLoaiDat: "COC",
      tenLoaiDat: "Đất trồng cỏ",
    },
    {
      maLoaiDat: "HNK",
      tenLoaiDat: "Đất trồng cây hàng năm khác",
    },
    {
      maLoaiDat: "BHK",
      tenLoaiDat: "Đất bằng trồng cây hàng năm khác",
    },
    /*
    {
      "maLoaiDat": "NHK",
      "tenLoaiDat": "Đất nương rẫy trồng cây hàng năm khác"
    },
    {
      "maLoaiDat": "CLN",
      "tenLoaiDat": "Đất trồng cây lâu năm"
    },
    {
      "maLoaiDat": "LNC",
      "tenLoaiDat": "Đất trồng cây công nghiệp lâu năm"
    },
    {
      "maLoaiDat": "LNQ",
      "tenLoaiDat": "Đất trồng cây ăn quả lâu năm"
    },
    {
      "maLoaiDat": "LNK",
      "tenLoaiDat": "Đất trồng cây lâu năm khác"
    },
    {
      "maLoaiDat": "LNP",
      "tenLoaiDat": "Đất lâm nghiệp"
    },
    {
      "maLoaiDat": "RSX",
      "tenLoaiDat": "Đất rừng sản xuất"
    },
    {
      "maLoaiDat": "RSN",
      "tenLoaiDat": "Đất có rừng tự nhiên sản xuất"
    },
    {
      "maLoaiDat": "RST",
      "tenLoaiDat": "Đất có rừng trồng sản xuất"
    },
    {
      "maLoaiDat": "RSK",
      "tenLoaiDat": "Đất khoanh nuôi phục hồi rừng sản xuất"
    },
    {
      "maLoaiDat": "RSM",
      "tenLoaiDat": "Đất trồng rừng sản xuất"
    },
    {
      "maLoaiDat": "RPH",
      "tenLoaiDat": "Đất rừng phòng hộ"
    },
    {
      "maLoaiDat": "RPN",
      "tenLoaiDat": "Đất có rừng tự nhiên phòng hộ"
    },
    {
      "maLoaiDat": "RPT",
      "tenLoaiDat": "Đất có rừng trồng phòng hộ"
    },
    {
      "maLoaiDat": "RPK",
      "tenLoaiDat": "Đất khoanh nuôi phục hồi rừng phòng hộ"
    },
    {
      "maLoaiDat": "RPM",
      "tenLoaiDat": "Đất trồng rừng phòng hộ"
    },
    {
      "maLoaiDat": "RDD",
      "tenLoaiDat": "Đất rừng đặc dụng"
    },
    {
      "maLoaiDat": "RDN",
      "tenLoaiDat": "Đất có rừng tự nhiên đặc dụng"
    },
    {
      "maLoaiDat": "RDT",
      "tenLoaiDat": "Đất có rừng trồng đặc dụng"
    },
    {
      "maLoaiDat": "RDK",
      "tenLoaiDat": "Đất khoanh nuôi phục hồi rừng đặc dụng"
    },
    {
      "maLoaiDat": "RDM",
      "tenLoaiDat": "Đất trồng rừng đặc dụng"
    },
    {
      "maLoaiDat": "NTS",
      "tenLoaiDat": "Đất nuôi trồng thuỷ sản"
    },
    {
      "maLoaiDat": "TSL",
      "tenLoaiDat": "Đất nuôi trồng thuỷ sản nước lợ, mặn"
    },
    {
      "maLoaiDat": "TSN",
      "tenLoaiDat": "Đất nuôi trồng thuỷ sản nước ngọt"
    },
    {
      "maLoaiDat": "LMU",
      "tenLoaiDat": "Đất làm muối"
    },
    {
      "maLoaiDat": "NKH",
      "tenLoaiDat": "Đất nông nghiệp khác"
    },
    {
      "maLoaiDat": "PNN",
      "tenLoaiDat": "Đất phi nông nghiệp"
    },
    {
      "maLoaiDat": "OTC",
      "tenLoaiDat": "Đất ở"
    },
    {
      "maLoaiDat": "ONT",
      "tenLoaiDat": "Đất ở tại nông thôn"
    },
    {
      "maLoaiDat": "ODT",
      "tenLoaiDat": "Đất ở tại đô thị"
    },
    {
      "maLoaiDat": "CDG",
      "tenLoaiDat": "Đất chuyên dùng"
    },
    {
      "maLoaiDat": "CTS",
      "tenLoaiDat": "Đất trụ sở cơ quan, công trình sự nghiệp"
    },
    {
      "maLoaiDat": "TSC",
      "tenLoaiDat": "Đất xây dựng trụ sở cơ quan"
    },
    {
      "maLoaiDat": "TSK",
      "tenLoaiDat": "Đất trụ sở khác"
    },
    {
      "maLoaiDat": "CQP",
      "tenLoaiDat": "Đất quốc phòng"
    },
    {
      "maLoaiDat": "CAN",
      "tenLoaiDat": "Đất an ninh"
    },
    {
      "maLoaiDat": "CSK",
      "tenLoaiDat": "Đất sản xuất, kinh doanh phi nông nghiệp"
    },
    {
      "maLoaiDat": "SKK",
      "tenLoaiDat": "Đất khu công nghiệp"
    },
    {
      "maLoaiDat": "SKC",
      "tenLoaiDat": "Đất cơ sở sản xuất phi nông nghiệp"
    },
    {
      "maLoaiDat": "SKS",
      "tenLoaiDat": "Đất sử dụng cho hoạt động khoáng sản"
    },
    {
      "maLoaiDat": "SKX",
      "tenLoaiDat": "Đất sản xuất vật liệu xây dựng, làm đồ gốm"
    },
    {
      "maLoaiDat": "CCC",
      "tenLoaiDat": "Đất sử dụng vào mục đích công cộng"
    },
    {
      "maLoaiDat": "DGT",
      "tenLoaiDat": "Đất giao thông"
    },
    {
      "maLoaiDat": "DTL",
      "tenLoaiDat": "Đất thuỷ lợi"
    },
    {
      "maLoaiDat": "DNL",
      "tenLoaiDat": "Đất công trình năng lượng"
    },
    {
      "maLoaiDat": "DBV",
      "tenLoaiDat": "Đất công trình bưu chính, viễn  thông"
    },
    {
      "maLoaiDat": "DVH",
      "tenLoaiDat": "Đất xây dựng cơ sở văn hóa"
    },
    {
      "maLoaiDat": "DYT",
      "tenLoaiDat": "Đất xây dựng cơ sở y tế"
    },
    {
      "maLoaiDat": "DGD",
      "tenLoaiDat": "Đất xây dựng cơ sở giáo dục - đào tạo"
    },
    {
      "maLoaiDat": "DTT",
      "tenLoaiDat": "Đất xây dựng cơ sở thể dục - thể thao"
    },
    {
      "maLoaiDat": "DKH",
      "tenLoaiDat": "Đất xây dựng cơ sở khoa học và công nghệ"
    },
    {
      "maLoaiDat": "DXH",
      "tenLoaiDat": "Đất xây dựng cơ sở dịch vụ xã hội"
    },
    {
      "maLoaiDat": "DCH",
      "tenLoaiDat": "Đất chợ"
    },
    {
      "maLoaiDat": "DDT",
      "tenLoaiDat": "Đất có di tích"
    },
    {
      "maLoaiDat": "DRA",
      "tenLoaiDat": "Đất bãi thải, xử lý chất thải"
    },
    {
      "maLoaiDat": "TTN",
      "tenLoaiDat": "Đất tôn giáo, tín ngưỡng"
    },
    {
      "maLoaiDat": "TON",
      "tenLoaiDat": "Đất cơ sở  tôn giáo"
    },
    {
      "maLoaiDat": "TIN",
      "tenLoaiDat": "Đất cơ sở  tín ngưỡng"
    },
    {
      "maLoaiDat": "NTD",
      "tenLoaiDat": "Đất nghĩa trang, nghĩa địa, nhà tang lễ, nhà hỏa táng"
    },
    {
      "maLoaiDat": "SMN",
      "tenLoaiDat": "Đất sông suối và mặt nước chuyên dùng"
    },
    {
      "maLoaiDat": "SON",
      "tenLoaiDat": "Đất sông, ngòi, kênh, rạch, suối"
    },
    {
      "maLoaiDat": "MNC",
      "tenLoaiDat": "Đất có mặt nước chuyên dùng"
    },
    {
      "maLoaiDat": "PNK",
      "tenLoaiDat": "Đất phi nông nghiệp khác"
    },
    {
      "maLoaiDat": "CSD",
      "tenLoaiDat": "Đất chưa sử dụng"
    },
    {
      "maLoaiDat": "BCS",
      "tenLoaiDat": "Đất bằng chưa sử dụng"
    },
    {
      "maLoaiDat": "DCS",
      "tenLoaiDat": "Đất đồi núi chưa sử dụng"
    },
    {
      "maLoaiDat": "NCS",
      "tenLoaiDat": "Núi đá không có rừng cây"
    },
    {
      "maLoaiDat": "MVB",
      "tenLoaiDat": "Đất có mặt nước ven biển"
    },
    {
      "maLoaiDat": "MVT",
      "tenLoaiDat": "Đất mặt nước ven biển nuôi trồng thuỷ sản"
    },
    {
      "maLoaiDat": "MVR",
      "tenLoaiDat": "Đất mặt nước ven biển có rừng ngập mặn"
    },
    {
      "maLoaiDat": "MVK",
      "tenLoaiDat": "Đất mặt nước ven biển có mục đích khác"
    },
    {
      "maLoaiDat": "ĐRM",
      "tenLoaiDat": ""
    },
    {
      "maLoaiDat": "DSN",
      "tenLoaiDat": "Đất xây dựng công trình sự nghiệp"
    },
    {
      "maLoaiDat": "DTS",
      "tenLoaiDat": "Đất xây dựng trụ sở của tổ chức sự nghiệp"
    },
    {
      "maLoaiDat": "DNG",
      "tenLoaiDat": "Đất xây dựng cơ sở ngoại giao"
    },
    {
      "maLoaiDat": "DSK",
      "tenLoaiDat": "Đất xây dựng công trình sự nghiệp khác"
    },
    {
      "maLoaiDat": "SKN",
      "tenLoaiDat": "Đất cụm công nghiệp"
    },
    {
      "maLoaiDat": "SKT",
      "tenLoaiDat": "Đất khu chế xuất"
    },
    {
      "maLoaiDat": "TMD",
      "tenLoaiDat": "Đất thương mại, dịch vụ"
    },
    {
      "maLoaiDat": "DDL",
      "tenLoaiDat": "Đất danh lam thắng cảnh"
    },
    {
      "maLoaiDat": "DSH",
      "tenLoaiDat": "Đất sinh hoạt cộng đồng"
    },
    {
      "maLoaiDat": "DKV",
      "tenLoaiDat": "Đất khu vui chơi, giải trí công cộng"
    },
    {
      "maLoaiDat": "DCK",
      "tenLoaiDat": "Đất công trình công cộng khác"
    },
    {
      "maLoaiDat": "",
      "tenLoaiDat": "Đất khu vực tổng hợp"
    },
    {
      "maLoaiDat": "DNT",
      "tenLoaiDat": "Khu dân cư nông thôn"
    },
    {
      "maLoaiDat": "KDT",
      "tenLoaiDat": "Đất đô thị"
    },
    {
      "maLoaiDat": "KBT",
      "tenLoaiDat": "Đất khu bảo tồn"
    },
    {
      "maLoaiDat": "KĐD",
      "tenLoaiDat": "Đất cơ sở bảo tồn đa dạng sinh học"
    },
    {
      "maLoaiDat": "CNC",
      "tenLoaiDat": "Đất khu công nghệ cao"
    },
    {
      "maLoaiDat": "KKT",
      "tenLoaiDat": "Đất khu kinh tế"
    },
    {
      "maLoaiDat": "aa",
      "tenLoaiDat": null
    },
    {
      "maLoaiDat": "sss",
      "tenLoaiDat": "sss"
    }
    */
  ],
  loaiKhuVucs: [
    {
      id: 1,
      ten: "Đô thị",
    },
    {
      id: 2,
      ten: "Nông thôn",
    },
    {
      id: 3,
      ten: "Đảo",
    },
    {
      id: 4,
      ten: "Làm muối",
    },
  ],
};

export const KhuVucVData = [
  {
    maKhuVuc: "KV1",
    tenKhuVuc: "Khu vực 1",
  },
  {
    maKhuVuc: "KV2",
    tenKhuVuc: "Khu vực 2",
  },
  {
    maKhuVuc: "KV3",
    tenKhuVuc: "Khu vực 3",
  },
  {
    maKhuVuc: "KV4",
    tenKhuVuc: "Khu vực 4",
  },
  {
    maKhuVuc: "KV5",
    tenKhuVuc: "Khu vực 5",
  },
];

export const KhungGiaDatData = [
  {
    "id": 1,
    "loaiKhuVucId": 1,
    "khuVuc": "Đô thị",
    "loaiDat": "LUC",
    "vitri": "1",
    "giaTien": 1000,
    "hieuLuc": "2022-01-08T10:09:32.857",
    "hetHieuLuc": "2030-12-08T10:09:32.857",
    "createdDate": "2022-12-08T10:09:32.857",
    "modifiedDate": "2022-12-08T10:09:32.857",
    "isDeleted": false,
    "createdUser": "string",
    "modifiedUser": null,
    "loaiKhuVuc": {
      "id": 1,
      "ten": "Đô thị",
      "isDeleted": false
    },
    tenLoaiKhuVuc: "Đô thị",
  },
  {
    "id": 2,
    "loaiKhuVucId": 2,
    "khuVuc": "Nông thôn",
    "loaiDat": "LUC",
    "vitri": "1",
    "giaTien": 500,
    "hieuLuc": "2022-01-08T10:09:32.857",
    "hetHieuLuc": "2030-12-08T10:09:32.857",
    "createdDate": "2022-12-08T10:09:32.857",
    "modifiedDate": "2022-12-08T10:09:32.857",
    "isDeleted": false,
    "createdUser": "string",
    "modifiedUser": null,
    "loaiKhuVuc": {
      "id": 2,
      "ten": "Nông thôn",
      "isDeleted": false
    },
    tenLoaiKhuVuc: "Nông thôn",
  },
  {
    id: 3,
    loaiKhuVucId: 3,
    khuVuc: "Đảo",
    loaiDat: "LUC",
    vitri: "1",
    giaTien: 1000,
    hieuLuc: "2022-01-08T10:09:32.857",
    hetHieuLuc: "2030-12-08T10:09:32.857",
    createdDate: "2022-12-08T10:09:32.857",
    modifiedDate: "2022-12-08T10:09:32.857",
    isDeleted: false,
    createdUser: "string",
    modifiedUser: null,
    loaiKhuVuc: {
      id: 1,
      ten: "Đảo",
      isDeleted: false,
    },
    tenLoaiKhuVuc: "Đảo",
  },
  {
    "id": 4,
    "loaiKhuVucId": 4,
    "khuVuc": "Làm muối",
    "loaiDat": "LUC",
    "vitri": "1",
    "giaTien": 1000,
    "hieuLuc": "2022-01-08T10:09:32.857",
    "hetHieuLuc": "2030-12-08T10:09:32.857",
    "createdDate": "2022-12-08T10:09:32.857",
    "modifiedDate": "2022-12-08T10:09:32.857",
    "isDeleted": false,
    "createdUser": "string",
    "modifiedUser": null,
    "loaiKhuVuc": {
      "id": 4,
      "ten": "Làm muối",
      "isDeleted": false
    },
    tenLoaiKhuVuc: "Làm muối",
  },
  {
    "id": 5,
    "loaiKhuVucId": 1,
    "khuVuc": "Đô thị",
    "loaiDat": "LUC",
    "vitri": "2",
    "giaTien": 800,
    "hieuLuc": "2022-01-08T10:09:32.857",
    "hetHieuLuc": "2030-12-08T10:09:32.857",
    "createdDate": "2022-12-08T10:09:32.857",
    "modifiedDate": "2022-12-08T10:09:32.857",
    "isDeleted": false,
    "createdUser": "string",
    "modifiedUser": null,
    "loaiKhuVuc": {
      "id": 1,
      "ten": "Đô thị",
      "isDeleted": false
    },
    "tenLoaiKhuVuc": "Đô thị"
  }
]


export const LichSuGiaDatData: ILichSuGiaDat[] = [
  {
    "soTo": 16,
    "soThua": 60,
    "tenDuong": "Đường Nguyễn Tất Thành",
    "tenHem": null,
    "tenDuongGiao": null,
    "phuongPhapDinhGia": "Giáp đường chính",
    "heSoTiepGiapDuong": 1,
    "chieuDaiHem": 0,
    "tongGia": 27296805,
    "giaThiTruong": 27296805,
    "thongTinDuongChinh": {
      "tenDuong": "Đường Nguyễn Tất Thành",
      "tenDoanDuong": null,
      "vung1": 10000,
      "vung2": 6500,
      "vung3": 5000,
      "vung4": 3700,
      "vung5": 3000
    },
    "chiTiets": [
      {
        "tenVung": "Vùng 1",
        "dienTichVung": 3504.57,
        "mdsd": "TSC",
        "dienTich": 3504.57,
        "heSo": 0.6,
        "gia": 21027420
      },
      {
        "tenVung": "Vùng 2",
        "dienTichVung": 2473.77,
        "mdsd": "TSC",
        "dienTich": 2473.1299999999997,
        "heSo": 0.39,
        "gia": 6269384.55
      }
    ],
    "geometries": [
      {
        "name": "Vùng 1",
        "area": 3504.5703429153623,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930941.670299999,1174216.9677999988,0],[11930936.008299999,1174218.5183999985,0],[11930917.497000001,1174223.5870000012,0],[11930892.663108673,1174230.3748958288,0],[11930892.962186407,1174231.6450347635,0],[11930894.984421967,1174237.2373089257,0],[11930897.638005022,1174242.5554737712,0],[11930900.887050619,1174247.5276099655,0],[11930904.087621575,1174251.3667650297,0],[11930908.689885907,1174267.5051969553,0],[11930917.067500144,1174296.7007454059,0],[11930966.091499999,1174283.1152999997,0],[11930957.5491,1174253.3456999995,0],[11930948.180500001,1174220.4935999997,0],[11930941.670299999,1174216.9677999988,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      },
      {
        "name": "Vùng 2",
        "area": 2473.766178337042,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930867.5381,1174261.7193000019,0],[11930870.193300001,1174270.7305000015,0],[11930870.7128,1174272.4941000007,0],[11930875.1105,1174287.4215999991,0],[11930880.8528,1174306.7364999987,0],[11930917.067500144,1174296.7007454059,0],[11930908.689885907,1174267.5051969553,0],[11930904.087621575,1174251.3667650297,0],[11930900.887050619,1174247.5276099655,0],[11930897.638005022,1174242.5554737712,0],[11930894.984421967,1174237.2373089257,0],[11930892.962186407,1174231.6450347635,0],[11930892.663108673,1174230.3748958285,0],[11930888.675999999,1174231.4646999985,0],[11930865.685899999,1174237.7492000014,0],[11930862.293499999,1174243.9151000008,0],[11930867.5381,1174261.7193000019,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      }
    ],
    "routeGeometries": []
  },
  {
    "soTo": 16,
    "soThua": 60,
    "tenDuong": "Đường Lê Duẩn",
    "tenHem": "Đường đô thị",
    "tenDuongGiao": null,
    "phuongPhapDinhGia": "Giáp đường hẻm",
    "heSoTiepGiapDuong": 1,
    "chieuDaiHem": 152.2,
    "tongGia": 5639316,
    "giaThiTruong": 5639316,
    "thongTinDuongChinh": {
      "tenDuong": "Đường Lê Duẩn",
      "tenDoanDuong": null,
      "vung1": 8000,
      "vung2": 5200,
      "vung3": 4000,
      "vung4": 2960,
      "vung5": 2400
    },
    "chiTiets": [
      {
        "tenVung": "Vùng 3",
        "dienTichVung": 3152.17,
        "mdsd": "TSC",
        "dienTich": 3152.17,
        "heSo": 0.3,
        "gia": 3782604
      },
      {
        "tenVung": "Vùng 4",
        "dienTichVung": 2826.16,
        "mdsd": "TSC",
        "dienTich": 2825.5299999999997,
        "heSo": 0.222,
        "gia": 1856712.2736
      }
    ],
    "geometries": [
      {
        "name": "Vùng 3",
        "area": 3152.172654184101,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930867.5381,1174261.7193000019,0],[11930870.193300001,1174270.7305000015,0],[11930870.7128,1174272.4941000007,0],[11930875.1105,1174287.4215999991,0],[11930880.8528,1174306.7364999987,0],[11930915.172202606,1174297.2259669567,0],[11930917.398751548,1174292.7636404275,0],[11930919.42099029,1174287.1713575751,0],[11930920.784533501,1174281.3805912342,0],[11930921.470941899,1174275.4696517398,0],[11930921.470933335,1174269.5184744904,0],[11930920.784508262,1174263.6075389467,0],[11930919.459524639,1174257.9470982568,0],[11930918.940022416,1174256.1834997013,0],[11930918.901447307,1174256.0531810196,0],[11930916.879195543,1174250.4609094535,0],[11930914.225598209,1174245.1427503491,0],[11930910.976540873,1174240.1706224047,0],[11930907.175961593,1174235.6117648042,0],[11930902.875256745,1174231.527827932,0],[11930899.018392107,1174228.6377938443,0],[11930888.675999999,1174231.4646999985,0],[11930865.685899999,1174237.7492000014,0],[11930862.293499999,1174243.9151000008,0],[11930867.5381,1174261.7193000019,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      },
      {
        "name": "Vùng 4",
        "area": 2826.1639019686736,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930941.670299999,1174216.9677999988,0],[11930936.008299999,1174218.5183999985,0],[11930917.497000001,1174223.5870000012,0],[11930899.018392107,1174228.6377938443,0],[11930902.875256745,1174231.527827932,0],[11930907.175961593,1174235.6117648042,0],[11930910.976540873,1174240.1706224047,0],[11930914.225598209,1174245.1427503491,0],[11930916.879195543,1174250.4609094535,0],[11930918.901447307,1174256.0531810196,0],[11930918.940022416,1174256.1834997013,0],[11930919.459524639,1174257.9470982568,0],[11930920.784508262,1174263.6075389467,0],[11930921.470933335,1174269.5184744904,0],[11930921.470941899,1174275.4696517398,0],[11930920.784533501,1174281.3805912342,0],[11930919.42099029,1174287.1713575751,0],[11930917.398751548,1174292.7636404275,0],[11930915.172202606,1174297.2259669565,0],[11930966.091499999,1174283.1152999997,0],[11930957.5491,1174253.3456999995,0],[11930948.180500001,1174220.4935999997,0],[11930941.670299999,1174216.9677999988,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      }
    ],
    "routeGeometries": [
      "{\"paths\":[[[11930864.442553265,1174272.419732864],[11930858.188200001,1174251.127700001],[11930857.1587,1174248.2179000005],[11930856.520500001,1174246.9697000012],[11930855.092999998,1174244.8539000005],[11930854.618900001,1174243.7851999998],[11930854.037999999,1174238.4541999996],[11930852.011300001,1174229.8548000008]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}",
      "{\"paths\":[[[11930852.011300001,1174229.8548000008],[11930835.9736,1174234.7188999988],[11930746.5715,1174262.9054999985]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
    ]
  },
  {
    "soTo": 16,
    "soThua": 60,
    "tenDuong": "Đường Bạch Đằng",
    "tenHem": "Đường đô thị",
    "tenDuongGiao": null,
    "phuongPhapDinhGia": "Giáp đường hẻm",
    "heSoTiepGiapDuong": 1,
    "chieuDaiHem": 147.3,
    "tongGia": 5639316,
    "giaThiTruong": 5639316,
    "thongTinDuongChinh": {
      "tenDuong": "Đường Bạch Đằng",
      "tenDoanDuong": null,
      "vung1": 8000,
      "vung2": 5200,
      "vung3": 4000,
      "vung4": 2960,
      "vung5": 2400
    },
    "chiTiets": [
      {
        "tenVung": "Vùng 3",
        "dienTichVung": 3152.17,
        "mdsd": "TSC",
        "dienTich": 3152.17,
        "heSo": 0.3,
        "gia": 3782604
      },
      {
        "tenVung": "Vùng 4",
        "dienTichVung": 2826.16,
        "mdsd": "TSC",
        "dienTich": 2825.5299999999997,
        "heSo": 0.222,
        "gia": 1856712.2736
      }
    ],
    "geometries": [
      {
        "name": "Vùng 3",
        "area": 3152.172654184101,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930867.5381,1174261.7193000019,0],[11930870.193300001,1174270.7305000015,0],[11930870.7128,1174272.4941000007,0],[11930875.1105,1174287.4215999991,0],[11930880.8528,1174306.7364999987,0],[11930915.172202606,1174297.2259669567,0],[11930917.398751548,1174292.7636404275,0],[11930919.42099029,1174287.1713575751,0],[11930920.784533501,1174281.3805912342,0],[11930921.470941899,1174275.4696517398,0],[11930921.470933335,1174269.5184744904,0],[11930920.784508262,1174263.6075389467,0],[11930919.459524639,1174257.9470982568,0],[11930918.940022416,1174256.1834997013,0],[11930918.901447307,1174256.0531810196,0],[11930916.879195543,1174250.4609094535,0],[11930914.225598209,1174245.1427503491,0],[11930910.976540873,1174240.1706224047,0],[11930907.175961593,1174235.6117648042,0],[11930902.875256745,1174231.527827932,0],[11930899.018392107,1174228.6377938443,0],[11930888.675999999,1174231.4646999985,0],[11930865.685899999,1174237.7492000014,0],[11930862.293499999,1174243.9151000008,0],[11930867.5381,1174261.7193000019,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      },
      {
        "name": "Vùng 4",
        "area": 2826.1639019686736,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930941.670299999,1174216.9677999988,0],[11930936.008299999,1174218.5183999985,0],[11930917.497000001,1174223.5870000012,0],[11930899.018392107,1174228.6377938443,0],[11930902.875256745,1174231.527827932,0],[11930907.175961593,1174235.6117648042,0],[11930910.976540873,1174240.1706224047,0],[11930914.225598209,1174245.1427503491,0],[11930916.879195543,1174250.4609094535,0],[11930918.901447307,1174256.0531810196,0],[11930918.940022416,1174256.1834997013,0],[11930919.459524639,1174257.9470982568,0],[11930920.784508262,1174263.6075389467,0],[11930921.470933335,1174269.5184744904,0],[11930921.470941899,1174275.4696517398,0],[11930920.784533501,1174281.3805912342,0],[11930919.42099029,1174287.1713575751,0],[11930917.398751548,1174292.7636404275,0],[11930915.172202606,1174297.2259669565,0],[11930966.091499999,1174283.1152999997,0],[11930957.5491,1174253.3456999995,0],[11930948.180500001,1174220.4935999997,0],[11930941.670299999,1174216.9677999988,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      }
    ],
    "routeGeometries": [
      "{\"paths\":[[[11930883.3627,1174357.2377000004],[11930885.125100002,1174353.9085999988],[11930886.038699999,1174351.4228999987],[11930886.307799999,1174349.258200001],[11930886.135899998,1174347.1700999998],[11930885.716200002,1174345.1451000012],[11930875.794799998,1174311.0667999983],[11930864.960711513,1174274.1837269913]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}",
      "{\"paths\":[[[11930883.3627,1174357.2377000004],[11930886.107500002,1174358.9305000007],[11930887.947700001,1174360.1770000011],[11930889.2049,1174361.3238000013],[11930890.110399999,1174362.561999999],[11930890.805599999,1174363.9272000007],[11930891.812199999,1174366.7146999985],[11930898.414000001,1174389.1323999986],[11930899.241799999,1174391.0612000003],[11930900.7991,1174393.4560000002],[11930901.144499999,1174394.3647000007],[11930901.173599999,1174395.6796999983],[11930899.5711,1174404.1055999994],[11930897.556000002,1174415.5267000012]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
    ]
  },
  {
    "soTo": 16,
    "soThua": 60,
    "tenDuong": "Đường Châu Văn Biếc",
    "tenHem": "Đường đô thị",
    "tenDuongGiao": null,
    "phuongPhapDinhGia": "Giáp đường hẻm",
    "heSoTiepGiapDuong": 1,
    "chieuDaiHem": 179.2,
    "tongGia": 3454081,
    "giaThiTruong": 3454081,
    "thongTinDuongChinh": {
      "tenDuong": "Đường Châu Văn Biếc",
      "tenDoanDuong": null,
      "vung1": 4900,
      "vung2": 3185,
      "vung3": 2450,
      "vung4": 1813,
      "vung5": 1470
    },
    "chiTiets": [
      {
        "tenVung": "Vùng 3",
        "dienTichVung": 3152.17,
        "mdsd": "TSC",
        "dienTich": 3152.17,
        "heSo": 0.3,
        "gia": 2316844.95
      },
      {
        "tenVung": "Vùng 4",
        "dienTichVung": 2826.16,
        "mdsd": "TSC",
        "dienTich": 2825.5299999999997,
        "heSo": 0.222,
        "gia": 1137236.26758
      }
    ],
    "geometries": [
      {
        "name": "Vùng 3",
        "area": 3152.172654184101,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930867.5381,1174261.7193000019,0],[11930870.193300001,1174270.7305000015,0],[11930870.7128,1174272.4941000007,0],[11930875.1105,1174287.4215999991,0],[11930880.8528,1174306.7364999987,0],[11930915.172202606,1174297.2259669567,0],[11930917.398751548,1174292.7636404275,0],[11930919.42099029,1174287.1713575751,0],[11930920.784533501,1174281.3805912342,0],[11930921.470941899,1174275.4696517398,0],[11930921.470933335,1174269.5184744904,0],[11930920.784508262,1174263.6075389467,0],[11930919.459524639,1174257.9470982568,0],[11930918.940022416,1174256.1834997013,0],[11930918.901447307,1174256.0531810196,0],[11930916.879195543,1174250.4609094535,0],[11930914.225598209,1174245.1427503491,0],[11930910.976540873,1174240.1706224047,0],[11930907.175961593,1174235.6117648042,0],[11930902.875256745,1174231.527827932,0],[11930899.018392107,1174228.6377938443,0],[11930888.675999999,1174231.4646999985,0],[11930865.685899999,1174237.7492000014,0],[11930862.293499999,1174243.9151000008,0],[11930867.5381,1174261.7193000019,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      },
      {
        "name": "Vùng 4",
        "area": 2826.1639019686736,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930941.670299999,1174216.9677999988,0],[11930936.008299999,1174218.5183999985,0],[11930917.497000001,1174223.5870000012,0],[11930899.018392107,1174228.6377938443,0],[11930902.875256745,1174231.527827932,0],[11930907.175961593,1174235.6117648042,0],[11930910.976540873,1174240.1706224047,0],[11930914.225598209,1174245.1427503491,0],[11930916.879195543,1174250.4609094535,0],[11930918.901447307,1174256.0531810196,0],[11930918.940022416,1174256.1834997013,0],[11930919.459524639,1174257.9470982568,0],[11930920.784508262,1174263.6075389467,0],[11930921.470933335,1174269.5184744904,0],[11930921.470941899,1174275.4696517398,0],[11930920.784533501,1174281.3805912342,0],[11930919.42099029,1174287.1713575751,0],[11930917.398751548,1174292.7636404275,0],[11930915.172202606,1174297.2259669565,0],[11930966.091499999,1174283.1152999997,0],[11930957.5491,1174253.3456999995,0],[11930948.180500001,1174220.4935999997,0],[11930941.670299999,1174216.9677999988,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      }
    ],
    "routeGeometries": [
      "{\"paths\":[[[11930883.3627,1174357.2377000004],[11930885.125100002,1174353.9085999988],[11930886.038699999,1174351.4228999987],[11930886.307799999,1174349.258200001],[11930886.135899998,1174347.1700999998],[11930885.716200002,1174345.1451000012],[11930875.794799998,1174311.0667999983],[11930864.960711513,1174274.1837269913]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}",
      "{\"paths\":[[[11930883.3627,1174357.2377000004],[11930878.434300002,1174358.4915999994],[11930874.912900001,1174359.6482999995],[11930869.920899998,1174361.6059000008],[11930813.4109,1174384.4616999999],[11930810.520799998,1174385.5416000001],[11930809.183600001,1174385.9373999983],[11930805.943100002,1174386.5188999996],[11930805.089299999,1174386.8986000009],[11930803.8365,1174387.7016999982],[11930800.7929,1174389.113499999],[11930793.6098,1174391.2826999985]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
    ]
  },
  {
    "soTo": 16,
    "soThua": 60,
    "tenDuong": "Đường Nguyễn Tất Thành",
    "tenHem": "Đường đô thị",
    "tenDuongGiao": null,
    "phuongPhapDinhGia": "Giáp đường hẻm",
    "heSoTiepGiapDuong": 1,
    "chieuDaiHem": 147.7,
    "tongGia": 7049145,
    "giaThiTruong": 7049145,
    "thongTinDuongChinh": {
      "tenDuong": "Đường Nguyễn Tất Thành",
      "tenDoanDuong": null,
      "vung1": 10000,
      "vung2": 6500,
      "vung3": 5000,
      "vung4": 3700,
      "vung5": 3000
    },
    "chiTiets": [
      {
        "tenVung": "Vùng 3",
        "dienTichVung": 3152.17,
        "mdsd": "TSC",
        "dienTich": 3152.17,
        "heSo": 0.3,
        "gia": 4728255
      },
      {
        "tenVung": "Vùng 4",
        "dienTichVung": 2826.16,
        "mdsd": "TSC",
        "dienTich": 2825.5299999999997,
        "heSo": 0.222,
        "gia": 2320890.342
      }
    ],
    "geometries": [
      {
        "name": "Vùng 3",
        "area": 3152.172654184101,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930867.5381,1174261.7193000019,0],[11930870.193300001,1174270.7305000015,0],[11930870.7128,1174272.4941000007,0],[11930875.1105,1174287.4215999991,0],[11930880.8528,1174306.7364999987,0],[11930915.172202606,1174297.2259669567,0],[11930917.398751548,1174292.7636404275,0],[11930919.42099029,1174287.1713575751,0],[11930920.784533501,1174281.3805912342,0],[11930921.470941899,1174275.4696517398,0],[11930921.470933335,1174269.5184744904,0],[11930920.784508262,1174263.6075389467,0],[11930919.459524639,1174257.9470982568,0],[11930918.940022416,1174256.1834997013,0],[11930918.901447307,1174256.0531810196,0],[11930916.879195543,1174250.4609094535,0],[11930914.225598209,1174245.1427503491,0],[11930910.976540873,1174240.1706224047,0],[11930907.175961593,1174235.6117648042,0],[11930902.875256745,1174231.527827932,0],[11930899.018392107,1174228.6377938443,0],[11930888.675999999,1174231.4646999985,0],[11930865.685899999,1174237.7492000014,0],[11930862.293499999,1174243.9151000008,0],[11930867.5381,1174261.7193000019,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      },
      {
        "name": "Vùng 4",
        "area": 2826.1639019686736,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930941.670299999,1174216.9677999988,0],[11930936.008299999,1174218.5183999985,0],[11930917.497000001,1174223.5870000012,0],[11930899.018392107,1174228.6377938443,0],[11930902.875256745,1174231.527827932,0],[11930907.175961593,1174235.6117648042,0],[11930910.976540873,1174240.1706224047,0],[11930914.225598209,1174245.1427503491,0],[11930916.879195543,1174250.4609094535,0],[11930918.901447307,1174256.0531810196,0],[11930918.940022416,1174256.1834997013,0],[11930919.459524639,1174257.9470982568,0],[11930920.784508262,1174263.6075389467,0],[11930921.470933335,1174269.5184744904,0],[11930921.470941899,1174275.4696517398,0],[11930920.784533501,1174281.3805912342,0],[11930919.42099029,1174287.1713575751,0],[11930917.398751548,1174292.7636404275,0],[11930915.172202606,1174297.2259669565,0],[11930966.091499999,1174283.1152999997,0],[11930957.5491,1174253.3456999995,0],[11930948.180500001,1174220.4935999997,0],[11930941.670299999,1174216.9677999988,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      }
    ],
    "routeGeometries": [
      "{\"paths\":[[[11930864.442553265,1174272.419732864],[11930858.188200001,1174251.127700001],[11930857.1587,1174248.2179000005],[11930856.520500001,1174246.9697000012],[11930855.092999998,1174244.8539000005],[11930854.618900001,1174243.7851999998],[11930854.037999999,1174238.4541999996],[11930852.011300001,1174229.8548000008]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}",
      "{\"paths\":[[[11930953.351399999,1174200.490699999],[11930947.342,1174203.0397000015],[11930941.4767,1174206.0857000016],[11930940.6391,1174206.246100001],[11930937.864300001,1174206.1477000006],[11930936.852200001,1174206.1867000014],[11930934.727400001,1174206.5234999992],[11930911.9001,1174212.6746000014],[11930905.9969,1174214.1878999993],[11930897.913199998,1174216.3660000004],[11930895.147300001,1174217.2580000013],[11930893.8213,1174217.7791999988],[11930892.146000002,1174218.4483999982],[11930888.693,1174219.5447999984],[11930864.814399999,1174226.1097999997],[11930852.011300001,1174229.8548000008]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
    ]
  },
  {
    "soTo": 16,
    "soThua": 60,
    "tenDuong": "Đg. Ngô Gia Tự",
    "tenHem": "Đường đô thị",
    "tenDuongGiao": null,
    "phuongPhapDinhGia": "Giáp đường hẻm",
    "heSoTiepGiapDuong": 1,
    "chieuDaiHem": 152.2,
    "tongGia": 7049145,
    "giaThiTruong": 7049145,
    "thongTinDuongChinh": {
      "tenDuong": "Đg. Ngô Gia Tự",
      "tenDoanDuong": null,
      "vung1": 1000,
      "vung2": 6500,
      "vung3": 5000,
      "vung4": 3700,
      "vung5": 3000
    },
    "chiTiets": [
      {
        "tenVung": "Vùng 3",
        "dienTichVung": 3152.17,
        "mdsd": "TSC",
        "dienTich": 3152.17,
        "heSo": 0.3,
        "gia": 4728255
      },
      {
        "tenVung": "Vùng 4",
        "dienTichVung": 2826.16,
        "mdsd": "TSC",
        "dienTich": 2825.5299999999997,
        "heSo": 0.222,
        "gia": 2320890.342
      }
    ],
    "geometries": [
      {
        "name": "Vùng 3",
        "area": 3152.172654184101,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930867.5381,1174261.7193000019,0],[11930870.193300001,1174270.7305000015,0],[11930870.7128,1174272.4941000007,0],[11930875.1105,1174287.4215999991,0],[11930880.8528,1174306.7364999987,0],[11930915.172202606,1174297.2259669567,0],[11930917.398751548,1174292.7636404275,0],[11930919.42099029,1174287.1713575751,0],[11930920.784533501,1174281.3805912342,0],[11930921.470941899,1174275.4696517398,0],[11930921.470933335,1174269.5184744904,0],[11930920.784508262,1174263.6075389467,0],[11930919.459524639,1174257.9470982568,0],[11930918.940022416,1174256.1834997013,0],[11930918.901447307,1174256.0531810196,0],[11930916.879195543,1174250.4609094535,0],[11930914.225598209,1174245.1427503491,0],[11930910.976540873,1174240.1706224047,0],[11930907.175961593,1174235.6117648042,0],[11930902.875256745,1174231.527827932,0],[11930899.018392107,1174228.6377938443,0],[11930888.675999999,1174231.4646999985,0],[11930865.685899999,1174237.7492000014,0],[11930862.293499999,1174243.9151000008,0],[11930867.5381,1174261.7193000019,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      },
      {
        "name": "Vùng 4",
        "area": 2826.1639019686736,
        "geometry": "{\"hasZ\":true,\"rings\":[[[11930941.670299999,1174216.9677999988,0],[11930936.008299999,1174218.5183999985,0],[11930917.497000001,1174223.5870000012,0],[11930899.018392107,1174228.6377938443,0],[11930902.875256745,1174231.527827932,0],[11930907.175961593,1174235.6117648042,0],[11930910.976540873,1174240.1706224047,0],[11930914.225598209,1174245.1427503491,0],[11930916.879195543,1174250.4609094535,0],[11930918.901447307,1174256.0531810196,0],[11930918.940022416,1174256.1834997013,0],[11930919.459524639,1174257.9470982568,0],[11930920.784508262,1174263.6075389467,0],[11930921.470933335,1174269.5184744904,0],[11930921.470941899,1174275.4696517398,0],[11930920.784533501,1174281.3805912342,0],[11930919.42099029,1174287.1713575751,0],[11930917.398751548,1174292.7636404275,0],[11930915.172202606,1174297.2259669565,0],[11930966.091499999,1174283.1152999997,0],[11930957.5491,1174253.3456999995,0],[11930948.180500001,1174220.4935999997,0],[11930941.670299999,1174216.9677999988,0]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
      }
    ],
    "routeGeometries": [
      "{\"paths\":[[[11930864.442553265,1174272.419732864],[11930858.188200001,1174251.127700001],[11930857.1587,1174248.2179000005],[11930856.520500001,1174246.9697000012],[11930855.092999998,1174244.8539000005],[11930854.618900001,1174243.7851999998],[11930854.037999999,1174238.4541999996],[11930852.011300001,1174229.8548000008]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}",
      "{\"paths\":[[[11930852.011300001,1174229.8548000008],[11930835.9736,1174234.7188999988],[11930746.5715,1174262.9054999985]]],\"spatialReference\":{\"wkid\":102100,\"latestWkid\":3857}}"
    ]
  }
]

export const PhuongPhapDinhGiaData = ["Giáp đường chính","Giáp đường hẻm","Giáp đường chính quy đổi thành đường hẻm","Giá vùng 5 cho thửa không giáp đường"]
    

